import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=28da3861&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./modal.vue?vue&type=style&index=0&id=28da3861&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "28da3861",
  "2da6c05e"
  
)

export default component.exports